import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';

@Component({
  selector: 'wealth-applet-get-credit-guids',
  standalone: true,
  imports: [CommonModule, NgxIcon],
  templateUrl: './get-credit-guids.component.html',
  styleUrl: './get-credit-guids.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetCreditGuidsComponent {}
